import { BUYER_PROGRAM_STATUS, MORTGAGE_PROGRAM_STATUS, REFINANCING_PROGRAM_STATUS, SELLER_PROGRAM_STATUS, TRADELINES_PROGRAM_STATUS } from "./re-program.contants";

export const reProgramStatusColor = (status: string) => {
    return (BUYER_PROGRAM_STATUS as any)[status]?.color ||
        (SELLER_PROGRAM_STATUS as any)[status]?.color ||
        (MORTGAGE_PROGRAM_STATUS as any)[status]?.color ||
        (REFINANCING_PROGRAM_STATUS as any)[status]?.color ||
        (TRADELINES_PROGRAM_STATUS as any)[status]?.color;
}

export const reProgramStatusBgColor = (status: string) => {
    return (BUYER_PROGRAM_STATUS as any)[status]?.bgColor ||
        (SELLER_PROGRAM_STATUS as any)[status]?.bgColor ||
        (MORTGAGE_PROGRAM_STATUS as any)[status]?.bgColor ||
        (REFINANCING_PROGRAM_STATUS as any)[status]?.bgColor ||
        (TRADELINES_PROGRAM_STATUS as any)[status]?.bgColor;
}


export const isDropdownDefaultOpen = (status: string) => {
    return (BUYER_PROGRAM_STATUS as any)[status]?.open ||
        (SELLER_PROGRAM_STATUS as any)[status]?.open ||
        (MORTGAGE_PROGRAM_STATUS as any)[status]?.open ||
        (REFINANCING_PROGRAM_STATUS as any)[status]?.open ||
        (TRADELINES_PROGRAM_STATUS as any)[status]?.open;
}

export const getStatusDropdownOptions = (form: "seller" | "buyer" | "refinancing" | "mortgage" | "tradelines") => {
    switch (form) {
        case "seller":
            return Object.values(SELLER_PROGRAM_STATUS).map(v => v.name);
        case "buyer":
            return Object.values(BUYER_PROGRAM_STATUS).map(v => v.name);
        case "refinancing":
            return Object.values(REFINANCING_PROGRAM_STATUS).map(v => v.name);
        case "mortgage":
            return Object.values(MORTGAGE_PROGRAM_STATUS).map(v => v.name);
        case "tradelines":
            return Object.values(TRADELINES_PROGRAM_STATUS).map(v => v.name);
    }
}

export const getInitStatusREProgram = (form: "Buyer" | "Seller" | "Tradelines" | "Mortgage" | "Refinancing") => {
    switch (form) {
        case "Seller":
            return SELLER_PROGRAM_STATUS["Initial Consultation"].name;
        case "Buyer":
            return BUYER_PROGRAM_STATUS["Open Escrow"].name;
        case "Refinancing":
            return REFINANCING_PROGRAM_STATUS["Initial Consultation"].name;
        case "Mortgage":
            return MORTGAGE_PROGRAM_STATUS["Initial Consultation"].name;
        case "Tradelines":
            return TRADELINES_PROGRAM_STATUS["Opening New Tradeline"].name;
    }
}

const getAllProgramsStatuses = () => {
    const statuses = [];
    statuses.push(...Object.values(BUYER_PROGRAM_STATUS).map(p => p.name));
    statuses.push(...Object.values(SELLER_PROGRAM_STATUS).map(p => p.name));
    statuses.push(...Object.values(MORTGAGE_PROGRAM_STATUS).map(p => p.name));
    statuses.push(...Object.values(REFINANCING_PROGRAM_STATUS).map(p => p.name));
    statuses.push(...Object.values(TRADELINES_PROGRAM_STATUS).map(p => p.name));
    return statuses.flat();
}

export const getAllPrograms = () => {
    const statuses = [];
    statuses.push(...Object.values(BUYER_PROGRAM_STATUS).map(p => p));
    statuses.push(...Object.values(SELLER_PROGRAM_STATUS).map(p => p));
    statuses.push(...Object.values(MORTGAGE_PROGRAM_STATUS).map(p => p));
    statuses.push(...Object.values(REFINANCING_PROGRAM_STATUS).map(p => p));
    statuses.push(...Object.values(TRADELINES_PROGRAM_STATUS).map(p => p));
    return statuses.flat();
}

export const ALL_RE_PROGRAM_STATUS = getAllProgramsStatuses();
export const ALL_RE_PROGRAMS_INFO = getAllPrograms();